import { Flex, Text } from "@chakra-ui/react";
import React from "react";
import { WithRequiredHasuraRoles } from "src/components/Permissions/WithRequiredHasuraRoles";
import { useFormTemplateContext } from "src/scenes/orgAdmin/formTemplates/formTemplateContext";
import * as AF from "src/types/formTemplate";
import { HasuraRole } from "src/types/hasuraRole";
import { useEditFormTemplateContext } from "../../context";
import { InternalOnlyTag } from "../QuestionForm/QuestionExtraInfo/InternalOnlyTag";
import { EditSectionButton } from "./EditSectionButton";
import { MoveSectionPopover } from "./MoveSectionPopover";
import { RemoveSectionButton } from "./RemoveSectionButton";

type Props = {
  section: AF.V2.Section;
};
export const SectionForm: React.FC<Props> = ({ section }) => {
  const context = useEditFormTemplateContext();
  const { mode } = useFormTemplateContext();
  const showRemoveButton = context.helpers.isUnpublishedSection(section.id);
  return (
    <Flex sx={{ containerType: "inline-size" }} flexGrow="1">
      <Flex
        direction="row"
        gap="3"
        alignItems="center"
        flexGrow="1"
        sx={{
          "@container (width < 1058px)": {
            flexDirection: "column",
            alignItems: "flex-start",
          },
        }}
      >
        <Flex flexGrow="1" direction="column" gap="4">
          <InternalOnlyTag section={section} />
          <Flex flexGrow="1" direction="column">
            <Text as="h1" fontSize="lg" fontWeight="400">
              {section.title}
            </Text>
            <Text
              as="span"
              color="blackAlpha.600"
              fontWeight="400"
              fontSize="lg"
            >
              <Text whiteSpace="nowrap" as="span">
                Section key:{" "}
              </Text>
              {section.key}
            </Text>
          </Flex>
        </Flex>

        {mode === "edit" ? (
          <Flex gap="3" flexWrap="wrap" flexShrink="0">
            {showRemoveButton && <RemoveSectionButton section={section} />}
            <MoveSectionPopover sectionId={section.id} />
            <WithRequiredHasuraRoles
              roles={[HasuraRole.ADMIN, HasuraRole.ORG_ADMIN]}
            >
              <EditSectionButton section={section} />
            </WithRequiredHasuraRoles>
          </Flex>
        ) : null}
      </Flex>
    </Flex>
  );
};
